import { useState, useCallback } from 'react'

import { authHeader, notifyError } from '../../api/'
import { refreshToken } from '../auth/'

const { REACT_APP_API_URL } = import.meta.env

export const useSetSensorsByUserId = () => {
  const [isLoading, setLoading] = useState(false)
  const [isError, setError] = useState(null)

  const setSensorsByUserId = useCallback(async (userId, sensors) => {
    setError(null)
    setLoading(true)
    try {
      await refreshToken()

      const url = `${REACT_APP_API_URL}/user/admin/users/${userId}/sensors/`
      const options = {
        method: 'PATCH',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify({ data: { sensors } }),
      }
      const response = await fetch(url, options)
      if (!response.ok) {
        const text = await response.text()
        throw new Error(text || `HTTP ${response.status}`)
      }
      return await response.json()
    } catch (error) {
      const message = error?.message || 'Fehler beim Aktualisieren'
      setError(message)
      notifyError(message)
      return null
    } finally {
      setLoading(false)
    }
  }, [])

  return { setSensorsByUserId, isLoading, isError }
}
